import { FeatureService } from './../core/services/feature/feature.service';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import {
  EnvironmentService,
  ConfigStateService,
  PermissionService,
  SessionStateService,
  eLayoutType,
  LocalizationService,
} from '@abp/ng.core';
import {
  eSettingManamagementSettingTabNames,
  SettingTabsService,
} from '@abp/ng.setting-management/config';
import { EmailSettingGroupComponent as CAEmailSettingGroupComponent } from './replacement/settings/email-setting-group/email-setting-group.component';
import { SaasSettingGroupComponent as CASaasSettingGroupComponent } from './replacement/settings/saas-setting-group/saas-setting-group.component';
import { saasSettingTabNames } from '@volo/abp.ng.saas/config';
import { AnalyticsSettingGroupComponent } from './administration/settings/analytics-setting-group/analytics-setting-group.component';
import { AutomaticQualityManagementSettingGroupComponent } from './administration/settings/automatic-quality-management-setting-group/automatic-quality-management-setting-group.component';
import { RecorderManagementSettingGroupComponent } from './administration/settings/recorder-management-setting-group/recorder-management-setting-group.component';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { PrivacySettingGroupComponent } from './administration/settings/privacy-setting-group/privacy-setting-group.component';
import { OtherSettingGroupComponent } from './administration/settings/other-setting-group/other-setting-group.component';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { IndexingSettingsComponent } from './administration/settings/indexing-settings/indexing-settings.component';
import { Store, UpdateState } from '@ngxs/store';
import { CanDeactivateState } from 'src/core/guards/can-deactivate.guard';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';
import { NavMenuItemService } from 'src/core/services/nav-menu/nav-menu-item.service';
import { CorporateIdentitySettingsService } from 'src/core/services/settings/corporate-identity-settings.service';
import { TimeZoneHelper } from 'src/core/services/helper/timezone-helper';
import { ObjectHelper } from 'src/core/helpers/object.helper';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { ScopeService } from 'src/core/services/administration/scope.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { eUserMenuItems } from '@abp/ng.theme.basic';
import { NavItemsService, UserMenuService } from '@abp/ng.theme.shared';
import { NotificationIconComponent } from 'src/ca-shared/nav-items/notification-icon/notification-icon.component';
import { ResetUserSettingsComponent } from 'src/ca-shared/nav-items/reset-user-settings/reset-user-settings.component';
import { AboutComponent } from 'src/ca-shared/nav-items/about/about.component';
import { CA_NAVIGATE_TO_MANAGE_PROFILE } from 'src/core/constants/ca-manage-profile.token';
import { CA_NAVIGATE_TO_SECURITY_LOGS } from 'src/core/constants/ca-security-logs.token';
import { LanguagesComponent } from 'src/ca-shared/nav-items/languages/languages.component';
import {
  PremiumReportingAddMenuService,
  PremiumReportingConfigService,
  PremiumReportingMenuService,
} from '@sestek/premium-reporting/config';
import { VideoPlayerIconComponent } from 'src/ca-shared/nav-items/video-player-icon/video-player-icon.component';
import { ClearCacheComponent } from 'src/ca-shared/nav-items/clear-cache/clear-cache.component';
import { ZendeskApplicationSettingsComponent } from './administration/settings/integration-settings/zendesk-application-settings/zendesk-application-settings.component';
import { ZoomMeetingApplicationSettingsComponent } from './administration/settings/integration-settings/zoom-meeting-application-settings/zoom-meeting-application-settings.component';
import { ZoomContactCenterApplicationSettingsComponent } from './administration/settings/integration-settings/zoom-contactcenter-application-settings/zoom-contactcenter-application-settings.component';
import { MatIconRegistry } from '@angular/material/icon';
import { SettingService } from 'src/core/services/settings/setting.service';
import { IntegrationSettingsComponent } from './administration/settings/integration-settings/integration-settings.component';
import { UserLoginDateChange } from 'src/core/actions/administration/user-login.action';
import { RealTimeSettingGroupComponent } from './administration/settings/real-time-setting-group/real-time-setting-group.component';
import { GenerativeAiSettingGroupComponent } from './administration/settings/generative-ai-setting-group/generative-ai-setting-group.component';
import { RestrictionsAndLimitationGroupComponent } from './administration/settings/restrictions-and-limitation-setting-group/restrictions-and-limitation-setting-group.component';
import { RoleConstants } from 'src/core/constants/role.constant';
import { FeatureManagementTabComponent } from '@abp/ng.feature-management';
import { RequiredMultiplePoliciesGuard } from 'src/core/guards/required-multiple-policies.guard';
import { AIDisclaimerModalComponent } from './ai-disclaimer/ai-disclaimer-modal.component';
import { UserService } from 'src/core/services/administration/user.service';
import { eAccountSettingTabNames } from '@volo/abp.ng.account/admin/config';
import { NgZone } from '@angular/core';
import {
  disableExternalView,
  enableExternalView,
  hasEmbeddedModeQuery,
  shouldUseExternalView,
} from './external-bootstrap/external-view-state';
import { AuthorizationService } from 'src/core/services/auth/authorization.service';
import { resolveLanguage } from './external/language-utils';
import { PasswordPlaceholderService } from 'src/core/services/password-placeholder/password-placeholder.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  readonly defaultLayout = eLayoutType.application;
  readonly isExternalBootstrapRoute = window.location.pathname.startsWith('/external');
  titleDictionary = new Map<string, string>([
    ['languages', 'LanguageManagement::Languages'],
    ['texts', 'LanguageManagement::LanguageTexts'],
    ['organization-units', 'AbpIdentity::OrganizationUnits'],
    ['roles', 'AbpIdentity::Roles'],
    ['users', 'AbpIdentity::Users'],
    ['identity/user-groups', 'UserGroup::Menu:UserGroups'],
    ['security-logs', 'AbpIdentity::SecurityLogs'],
    ['list', 'PremiumReporting::Menu:PremiumReportsList'],
    ['view', 'PremiumReporting::Menu:PremiumReportsView'],
    ['tenants', 'Saas::Tenants'],
    ['editions', 'Saas::Editions'],
  ]);
  private currentTitle: string;
  private notificationTitleInterval: any;
  private notificationCount: number = 0;
  private notificationTitleState: boolean = true;
  idParam: number = null;
  private modalShown = false;
  private observer?: MutationObserver;
  private scheduled = false;
  private readonly SETTINGS_URL_PREFIX = '/setting-management';
  private readonly HIDDEN_TAB_RESOURCE_KEYS = ['AbpAccount::IdleSessionTimeout'];
  private readonly SSO_HANDOFF_ALLOWED_ORIGINS_SETTING = 'SSOHandoff.AllowedOrigins';
  private readonly externalMessageHandler = (event: MessageEvent<unknown>): void => {
    if (!this.isAllowedExternalMessage(event)) {
      return;
    }

    const data = event.data as { type?: unknown; language?: unknown; path?: unknown };
    if (data?.type === 'ca-embedded:logout') {
      void this.logoutExternalSession();
      return;
    }

    if (data?.type === 'ca-embedded:navigate' && typeof data.path === 'string') {
      this.navigateEmbeddedView(data.path);
      return;
    }

    if (data?.type !== 'ca-embedded:set-language' || typeof data.language !== 'string') {
      return;
    }

    this.sessionStateService.setLanguage(data.language);
  };

  constructor(
    private settingTabs: SettingTabsService,
    private configStateService: ConfigStateService,
    private store: Store,
    private featureService: FeatureService,
    private settingService: SettingService,
    private scopeService: ScopeService,
    readonly router: Router,
    private oAuthService: OAuthService,
    private menuItemService: NavMenuItemService,
    readonly timeZoneHelper: TimeZoneHelper,
    private corporateIdentitySettingsService: CorporateIdentitySettingsService,
    private environment: EnvironmentService,
    private ngbConfig: NgbConfig,
    private navItemsService: NavItemsService,
    private userMenuService: UserMenuService,
    private injector: Injector,
    private premiumReportingConfigService: PremiumReportingConfigService,
    private premiumReportingMenuService: PremiumReportingMenuService,
    private premiumReportingAddMenuService: PremiumReportingAddMenuService,
    private permissionService: PermissionService,
    private matIconRegistry: MatIconRegistry,
    private requiredMultiplePoliciesGuard: RequiredMultiplePoliciesGuard,
    private domSanitizer: DomSanitizer,
    private modalService: NgbModal,
    private userService: UserService,
    private ngZone: NgZone,
    private sessionStateService: SessionStateService,
    private authorizationService: AuthorizationService,
    private passwordPlaceholderService: PasswordPlaceholderService,
    private localizationService: LocalizationService,
  ) {
    const language = new URLSearchParams(window.location.search).get('lang');
    if (language) {
      const localization = this.configStateService.getOne('localization');
      const supportedLanguages = localization?.languages ?? [];
      this.sessionStateService.setLanguage(resolveLanguage(language, supportedLanguages));
    }

    if (hasEmbeddedModeQuery(window.location.search) || shouldUseExternalView()) {
      enableExternalView();
    } else {
      disableExternalView();
    }

    if (this.isExternalBootstrapRoute) {
      return;
    }

    const navigateToManageProfile = this.injector.get(CA_NAVIGATE_TO_MANAGE_PROFILE);
    const navigateToSecurityLogs = this.injector.get(CA_NAVIGATE_TO_SECURITY_LOGS);

    this.configStateService.getDeep$('currentUser.id').subscribe(user => {
      if (user != null) {
        const actions = new UpdateState();
        this.store.dispatch(actions);
      }
    });

    let tenantId = this.configStateService.getDeep(['currentUser', 'tenantId']);
    let isHost = tenantId == null;

    this.ngbConfig.animation = false;

    this.applyCorporateIdentitySettings();
    this.registerCustomIcons();

    this.oAuthService.events.pipe(filter(event => event?.type === 'logout')).subscribe(event => {
      CanDeactivateState.hasLogoutBeenInitiated = true;
    });

    this.featureService.checkRoutesForFeatures();
    this.requiredMultiplePoliciesGuard.checkRoutesForMultiplePolicies();
    this.settingService.checkRoutesForSettings();
    this.scopeService.checkRoutesForScopes();

    // if the user clicks the back button, ask the CanDeactivateGuard to defend against this.
    window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);

    // Upon successful navigation, ensure that the CanDeactivateGuard no longer defends against back button clicks
    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false)),
      )
      .subscribe(e => {
        this.checkInitialSetup();

        const navigation = this.router.getCurrentNavigation();

        if (navigation?.extras?.state && navigation.extras.state.settings) {
          const tabId = navigation.extras.queryParams?.tabId;

          setTimeout(() => {
            const tab = document.getElementById(tabId);

            if (tab) {
              tab.click();
            }
          }, 500);
        }

        const url = (e.urlAfterRedirects || e.url || '').toLowerCase();
        const isSettings = url.startsWith('/setting-management');

        if (isSettings) {
          this.startSettingsTabHider();
        } else {
          this.stopSettingsTabHider();
        }
      });

    Date.prototype.toJSON = function () {
      var copiedDate = new Date(this.getTime());
      const minutesDiff =
        this.getMinutes() -
        (timeZoneHelper.GetSystemTimeZoneOffsetInMinutes() + this.getTimezoneOffset());
      copiedDate.setMinutes(minutesDiff);
      var result = copiedDate.toISOString();
      return result;
    };

    this.navItemsService.addItems([
      {
        id: 'VideoPlayerIcon',
        order: 1,
        component: VideoPlayerIconComponent,
      },
    ]);

    this.navItemsService.addItems([
      {
        id: 'NotificationIcon',
        order: 2,
        component: NotificationIconComponent,
      },
    ]);

    this.navItemsService.patchItem(eThemeLeptonComponents.Languages, {
      component: LanguagesComponent,
    });

    const userItems: any[] = [
      {
        id: 'ResetUserSettingsLink',
        order: 101,
        component: ResetUserSettingsComponent,
      },
      {
        id: 'AboutLink',
        order: 103,
        component: AboutComponent,
      },
    ];

    if (isHost) {
      userItems.push({
        id: 'ClearCacheLink',
        order: 102,
        component: ClearCacheComponent,
      });
    }

    this.userMenuService.addItems(userItems);

    this.userMenuService.patchItem(eUserMenuItems.Logout, {
      order: 104,
    });

    this.userMenuService.patchItem(eUserMenuItems.MyAccount, {
      action: () => navigateToManageProfile(),
    });

    this.userMenuService.patchItem('UserMenu.SecurityLogs', {
      action: () => navigateToSecurityLogs(),
    });

    this.userMenuService.removeItem('UserMenu.LinkedAccounts');
    var impersonateUserId = this.configStateService.getDeep('currentUser.impersonatorUserId');

    if (impersonateUserId) {
      this.userMenuService.removeItem(eUserMenuItems.MyAccount);
      this.userMenuService.removeItem('UserMenu.SecurityLogs');
    }

    this.settingTabs.patch(eSettingManamagementSettingTabNames.EmailSettingGroup, {
      name: eSettingManamagementSettingTabNames.EmailSettingGroup,
      component: CAEmailSettingGroupComponent,
    });

    this.settingTabs.patch(saasSettingTabNames.SaasManagement, {
      name: saasSettingTabNames.SaasManagement,
      component: CASaasSettingGroupComponent,
    });

    this.initializeLogoutControl();

    this.checkAndShowDisclaimer();
  }

  private checkAndShowDisclaimer(): void {
    const isInitialSetupCompleted = this.configStateService.getSetting(
      'Global.IsInitialTenantSetupCompleted',
    );

    if (
      !this.oAuthService.hasValidAccessToken() ||
      this.modalShown ||
      isInitialSetupCompleted === 'False'
    ) {
      return;
    }

    this.userService.getConfirmedAiUsageDisclaimer().subscribe({
      next: confirmed => {
        if (!confirmed && !this.modalShown) {
          this.showAiDisclaimerModal();
        }
      },
      error: error => {
        console.error('AI Disclaimer check failed:', error);
      },
    });
  }

  private showAiDisclaimerModal(): void {
    this.modalShown = true;

    const modalRef = this.modalService.open(AIDisclaimerModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'ai-disclaimer-modal',
      centered: true,
    });

    modalRef.result.then(
      () => {
        this.modalShown = false;
      },
      () => {
        this.modalShown = false;
      },
    );
  }

  applyCorporateIdentitySettings() {
    this.corporateIdentitySettingsService.get().subscribe(result => {
      const logoFileBase64Uri = `data:${result.logoFileContentType};base64,${result.logoFileBytes}`;

      const environment = ObjectHelper.deepCopy(this.environment.getEnvironment());
      environment.application.name = result.title;
      environment.application.logoUrl = logoFileBase64Uri;
      this.environment.setState(environment);
      this.setLogo(logoFileBase64Uri);

      const faviconFileBase64Uri = `data:${result.faviconFileContentType};base64,${result.faviconFileBytes}`;
      this.setFavicon(faviconFileBase64Uri);
    });
  }

  setLogo(logoFileBase64Uri: string) {
    const logoUrl = `url("${logoFileBase64Uri}")`;
    document.documentElement.style.setProperty('--logo', logoUrl, 'important');
    document.documentElement.style.setProperty('--logo-reverse', logoUrl, 'important');
  }

  setFavicon(faviconFileBase64Uri: string) {
    const favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
    favIcon.href = faviconFileBase64Uri;
  }

  ngOnInit() {
    if (this.isExternalBootstrapRoute) {
      return;
    }

    if (shouldUseExternalView()) {
      window.addEventListener('message', this.externalMessageHandler);
    }

    this.checkInitialSetup();

    this.saveUserLoginState();

    this.passwordPlaceholderService.start();

    this.settingTabs.add([
      {
        name: 'Settings::Indexing',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: IndexingSettingsComponent,
      },
      {
        name: 'Settings::ZoomMeetingApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZoomMeetingApplicationSettingsComponent,
      },
      {
        name: 'Settings::ZoomContactCenterApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZoomContactCenterApplicationSettingsComponent,
      },
      {
        name: 'Settings::ZendeskApplication',
        requiredPolicy: PermissionConstants.SettingManagement,
        component: ZendeskApplicationSettingsComponent,
      },
      {
        name: 'Settings::Analytics',
        component: AnalyticsSettingGroupComponent,
      },
      {
        name: 'Settings::RealTime',
        component: RealTimeSettingGroupComponent,
      },
      {
        name: 'Settings::AutomaticQualityManagement',
        component: AutomaticQualityManagementSettingGroupComponent,
      },
      {
        name: 'Settings::RecorderManagement',
        component: RecorderManagementSettingGroupComponent,
      },
      {
        name: 'Settings::OpenAiSettings',
        component: GenerativeAiSettingGroupComponent,
      },
      {
        name: 'Settings::RestrictionsAndLimitation',
        component: RestrictionsAndLimitationGroupComponent,
      },
      {
        name: 'Settings::Privacy',
        component: PrivacySettingGroupComponent,
      },
      {
        name: 'Settings::Other',
        component: OtherSettingGroupComponent,
      },
      {
        name: 'Settings::Integration',
        component: IntegrationSettingsComponent,
      },
      {
        name: 'AbpFeatureManagement::Menu:FeatureManagement',
        requiredPolicy: 'FeatureManagement.ManageHostFeatures',
        component: FeatureManagementTabComponent,
      },
    ]);

    if (this.settingTabs.find(x => x.name == 'AbpIdentity::Menu:IdentityManagement')) {
      this.settingTabs.patch('AbpIdentity::Menu:IdentityManagement', {
        name: 'AbpIdentity::Settings:IdentityManagement',
      });
    }

    this.settingTabs.remove(['LeptonThemeManagement::Menu:LeptonThemeSettings']);

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.AttachedData) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.IgnoredWords) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.Sources) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.TagAndAutoTagging) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.PronunciationManagement)
      )
    ) {
      this.settingTabs.remove(['Settings::Analytics']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.RealTime) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      )
    ) {
      this.settingTabs.remove(['Settings::RealTime']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.QualityManagement) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.QualityManagement) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.ReasonPool)
      )
    ) {
      this.settingTabs.remove(['Settings::AutomaticQualityManagement']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.CallRecorder) &&
        (this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
          this.permissionService.getGrantedPolicy(PermissionConstants.CallRecorderManagement))
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.ScreenRecorder) &&
        (this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
          this.permissionService.getGrantedPolicy(PermissionConstants.ScreenRecorderManagement))
      )
    ) {
      this.settingTabs.remove(['Settings::RecorderManagement']);
    }

    if (
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)
      ) &&
      !(
        this.featureService.isEnabled(FeatureConstants.Analytics) &&
        this.featureService.isEnabled(FeatureConstants.AskGenAi) &&
        this.permissionService.getGrantedPolicy(PermissionConstants.RootCause)
      )
    ) {
      this.settingTabs.remove(['Settings::OpenAiSettings']);
    }

    const roles: string[] = this.configStateService.getDeep('currentUser.roles') ?? [];
    const isAdmin = roles.includes(RoleConstants.admin);
    if (!isAdmin) {
      this.settingTabs.remove(['Settings::RestrictionsAndLimitation']);
    }

    if (!this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)) {
      this.settingTabs.remove(['Settings::Privacy']);
    }

    if (
      !(
        this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.Department) ||
        this.permissionService.getGrantedPolicy(PermissionConstants.GenericLookup)
      )
    ) {
      this.settingTabs.remove(['Settings::Other']);
    }

    if (!this.permissionService.getGrantedPolicy(PermissionConstants.SettingManagement)) {
      this.settingTabs.remove(['Settings::Integration']);
    }

    if (!this.isHostUser()) {
      this.settingTabs.remove(['Settings::Indexing']);
      this.settingTabs.remove(['Settings::ZoomMeetingApplication']);
      this.settingTabs.remove(['Settings::ZoomContactCenterApplication']);
      this.settingTabs.remove(['Settings::ZendeskApplication']);
    }

    if (this.isHostUser()) {
      this.settingTabs.remove(['Settings::Integration']);
    }

    this.settingTabs.remove(['PremiumReporting::Menu:PremiumReports']);

    if (
      this.permissionService.getGrantedPolicy(PermissionConstants.PremiumReports) &&
      this.featureService.isEnabled(FeatureConstants.PremiumReporting)
    ) {
      this.getPremiumReportingMenuList();
      this.premiumReportingMenuService.premiumReportingMenuChange.subscribe(() =>
        this.getPremiumReportingMenuList(),
      );
    }

    this.settingTabs.remove([eAccountSettingTabNames.TimeZone]);

    this.menuItemService.overrideNavMenuItemIcons();
  }

  getPremiumReportingMenuList() {
    this.premiumReportingConfigService.get({ maxResultCount: 50 }).subscribe(res => {
      const itemsWithLiteralNames = res.items.map(item => ({
        ...item,
        name: `::${item.name}`,
      }));

      this.premiumReportingAddMenuService.addMenu(itemsWithLiteralNames);
      this.menuItemService.overridePremiumReportsNavMenuItemIcons();
    });
  }

  isHostUser(): boolean {
    let tenantId = this.configStateService.getDeep(['currentUser', 'tenantId']);
    return tenantId == null;
  }

  checkInitialSetup() {
    const tenantId = this.configStateService.getDeep('currentUser.tenantId');

    const isInitialSetupCompleted = this.configStateService.getSetting(
      'Global.IsInitialTenantSetupCompleted',
    );

    if (
      this.oAuthService.hasValidAccessToken() &&
      tenantId &&
      isInitialSetupCompleted === 'False'
    ) {
      this.router.navigate(['/initial-setup']);
    }
  }

  saveUserLoginState() {
    if (this.oAuthService.hasValidAccessToken()) {
      this.saveState();
      this.authorizationService.refreshAccessKey();
    }
  }

  saveState() {
    const date = new Date();
    const userLoginAction = new UserLoginDateChange(date);
    this.store.dispatch(userLoginAction);
  }

  ngOnDestroy(): void {
    if (this.isExternalBootstrapRoute) {
      return;
    }

    window.removeEventListener('message', this.externalMessageHandler);

    this.stopSettingsTabHider();
    this.passwordPlaceholderService.stop();
  }

  private async logoutExternalSession(): Promise<void> {
    const authServerOrigin = new URL(this.oAuthService.tokenEndpoint).origin;

    try {
      if (this.oAuthService.getAccessToken()) {
        await this.oAuthService.revokeTokenAndLogout();

        if (this.oAuthService.logoutUrl) {
          return;
        }
      }
    } catch {
      // Fall through so local tokens and the AuthServer session are still cleared.
    }

    this.oAuthService.logOut(true);
    window.location.replace(new URL('/account/logout', authServerOrigin).toString());
  }

  private isAllowedExternalMessage(event: MessageEvent<unknown>): boolean {
    if (!shouldUseExternalView() || event.source !== window.parent) {
      return false;
    }

    const settingValue = this.configStateService.getSetting(
      this.SSO_HANDOFF_ALLOWED_ORIGINS_SETTING
    );

    return (settingValue ?? '')
      .split(',')
      .map(value => value.trim())
      .filter(Boolean)
      .some(value => this.isMatchingOrigin(value, event.origin));
  }

  private isMatchingOrigin(configuredOrigin: string, messageOrigin: string): boolean {
    try {
      const url = new URL(configuredOrigin);
      const isHttpOrigin = url.protocol === 'https:' || url.protocol === 'http:';
      const containsOnlyOrigin =
        url.username === '' &&
        url.password === '' &&
        url.pathname === '/' &&
        url.search === '' &&
        url.hash === '';

      return isHttpOrigin && containsOnlyOrigin && url.origin === messageOrigin;
    } catch {
      return false;
    }
  }

  private navigateEmbeddedView(path: string): void {
    if (!path.startsWith('/') || path.startsWith('//')) {
      return;
    }

    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) {
      return;
    }

    void this.router.navigateByUrl(`${url.pathname}${url.search}${url.hash}`);
  }

  private loadCrazyEgg() {
    let node = document.createElement('script');
    node.src = '//script.crazyegg.com/pages/scripts/0120/5459.js';
    node.type = 'text/javascript';
    node.async = true;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  private registerCustomIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'open-ai',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/icons/open-ai.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'ai-insights',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/icons/ai-insights.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'positive-feedback',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/icons/positive-feedback.svg',
      ),
    );
    this.matIconRegistry.addSvgIcon(
      'negative-feedback',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/icons/negative-feedback.svg',
      ),
    );
  }

  private checkIntegration() {
    let amazonIntegration = this.featureService.isEnabled(FeatureConstants.AmazonIntegration);
    let amazonIntegrationOutOfMarketplace = this.featureService.isEnabled(FeatureConstants.AmazonIntegrationOutOfMarketplace);
    let amazonS3Integration = this.featureService.isEnabled(FeatureConstants.AmazonS3Integration);
    let aloTechIntegration = this.featureService.isEnabled(FeatureConstants.AloTechIntegration);
    let aloTechV3Integration = this.featureService.isEnabled(FeatureConstants.AloTechV3Integration);
    let puzzelIntegration = this.featureService.isEnabled(FeatureConstants.PuzzelIntegration);
    let GenesysIntegration = this.featureService.isEnabled(FeatureConstants.GenesysIntegration);
    let GenesysGirIntegration = this.featureService.isEnabled(FeatureConstants.GenesysGIRIntegration);
    let GenesysIntegrationOutOfMarketplace = this.featureService.isEnabled(FeatureConstants.GenesysIntegrationOutOfMarketplace);
    let ZendeskIntegration = this.featureService.isEnabled(FeatureConstants.ZendeskIntegration);
    let ZoomMeetingIntegration = this.featureService.isEnabled(FeatureConstants.ZoomMeetingIntegration);
    let ZoomContactCenterIntegration = this.featureService.isEnabled(FeatureConstants.ZoomContactCenterIntegration);
    let twilioIntegration = this.featureService.isEnabled(FeatureConstants.TwilioIntegration);
    let dynamicsIntegration = this.featureService.isEnabled(FeatureConstants.DynamicsIntegration);
    let niceIntegration = this.featureService.isEnabled(FeatureConstants.NiceIntegration);

    return (
      amazonIntegration ||
      amazonIntegrationOutOfMarketplace ||
      amazonS3Integration ||
      aloTechIntegration ||
      aloTechV3Integration ||
      puzzelIntegration ||
      GenesysIntegration ||
      GenesysIntegrationOutOfMarketplace ||
      GenesysGirIntegration ||
      ZendeskIntegration ||
      ZoomContactCenterIntegration ||
      ZoomMeetingIntegration ||
      twilioIntegration ||
      dynamicsIntegration ||
      niceIntegration
    );
  }

  private startSettingsTabHider(): void {
    if (this.observer) {
      this.runHideTabs();
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.runHideTabs();

      const target =
        (document.querySelector('#AccountSettingsForm') as HTMLElement) ||
        (document.querySelector('abp-setting-management') as HTMLElement) ||
        document.body;

      this.observer = new MutationObserver(() => {
        if (this.scheduled) {
          return;
        }

        this.scheduled = true;
        requestAnimationFrame(() => {
          this.scheduled = false;
          this.hideTabs();
        });
      });

      this.observer.observe(target, { childList: true, subtree: true });
    });
  }

  private stopSettingsTabHider(): void {
    this.observer?.disconnect();
    this.observer = undefined;
    this.scheduled = false;
  }

  private runHideTabs(): void {
    this.hideTabs();
    requestAnimationFrame(() => this.hideTabs());
  }

  private hideTabs(): void {
    const url = (this.router.url || '').toLowerCase();
    if (!url.startsWith(this.SETTINGS_URL_PREFIX)) {
      return;
    }

    const hiddenTitles = this.HIDDEN_TAB_RESOURCE_KEYS.map(key =>
      this.localizationService.instant(key).trim().toLowerCase(),
    );

    document.querySelectorAll<HTMLElement>('.nav-link').forEach(link => {
      const text = (link.textContent ?? '').trim().toLowerCase();
      if (hiddenTitles.some(t => text.includes(t))) {
        link.closest('.nav-item')?.remove();
      }
    });
  }

  private initializeLogoutControl() {
    this.oAuthService.events.subscribe(event => {
      if (event.type === 'logout' && this.oAuthService['persistRedirectUri'] === undefined) {
        this.oAuthService.redirectUri = window.location.origin;
      }
    });
  }
}
